<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px;height:auto !important;"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Proforma List</b-navbar-brand>
          <b-navbar-nav class="ml-auto mr-auto" center>
            <b-nav-form>
              <b-button @click="filterClear">Clear</b-button>
              <b-button
                size="sm"
                class="ml-1 mr-1"
                @click="getReportsReverse('Proforma_EXCEL')"
                variant="outline-info"
                >Export</b-button
              >
              <Filter-Agency-Modal />
              <FilterCBModal />
              <ClientCard />
               <ShipmentTrackCard />
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <b-card>
          <b-row class="mt-2">
            <b-col md="3">
              <label for="blType">Client </label>
              <model-list-select
                :list="$store.getters['common/getAllClientList']"
                id="clientNamenew"
                v-model="Filter.clientIdFilter"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select Client Name"
                @input="SearchFilter"
              ></model-list-select>
            </b-col>

            <b-col  md="3">
              <label>Invoice Date :</label>
              <date-range-picker
                :opens="openLeft"
                :always-show-calendars="showCal"
                v-model="dateRange"
                :startDate="startDate"
                :endDate="endDate"
                :locale-data="locale"
                @update="SearchFilter"
              >
              </date-range-picker>
            </b-col>
            <b-col  md="3"
              ><label>Invoice No</label>
              <b-form-input
                :formatter="capitalizeAll"
                v-model="Filter.InvoiceNoFilter"
                placeholder="Invoice Number"
                @input="SearchFilter"
              ></b-form-input>
            </b-col>
            <b-col  md="3"
              ><label>POR</label>
              <model-list-select
                @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                @searchchange="
                  getLocationList($event, 'All', 'finalAllPlaceDataPOR')
                "
                :list="$store.getters['common/getAllPORList']"
                v-model="Filter.PORfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Place of Receipt"
                @update="SearchFilter"
              ></model-list-select>
            </b-col>
            <b-col  md="3"
              ><label>POD</label>
              <model-list-select
                @input="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                @searchchange="
                  getLocationList($event, 'All', 'finalAllPlaceDataPOD')
                "
                :list="$store.getters['common/getAllPODList']"
                v-model="Filter.PODfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Port of Discharge"
                @update="SearchFilter"
              ></model-list-select>
            </b-col>
            <b-col  md="3"
              ><label>Container Type</label>
              <model-list-select
                :list="$store.getters['common/getAllContainerTypeList']"
                v-model="Filter.containerTypeFilter"
                option-value="containerTypeId"
                option-text="containerType"
                placeholder="Select Container Type"
                @input="SearchFilter"
              ></model-list-select>
            </b-col>
            <b-col  md="3"
              ><label>Shipping Line</label>
              <model-list-select
                :list="$store.getters['common/getAllShippingLineList']"
                v-model="Filter.shippingLineFilter"
                option-value="shippingId"
                option-text="shippingLine"
                placeholder="Select Shipping Line"
                @input="SearchFilter"
              ></model-list-select>
            </b-col>
            <b-col  md="3"
              ><label>Air Line</label>
              <model-list-select
                :list="$store.getters['common/getAllAirLineList']"
                v-model="Filter.airLineFilter"
                option-value="airlineId"
                option-text="airlineName"
                placeholder="Select Air Line"
                @input="SearchFilter"
              ></model-list-select>
            </b-col>
            <b-col  md="3"
              ><label>Job Type</label>
              <model-list-select
                :list="jobList"
                v-model="Filter.jobTypeFilter"
                option-value="jv"
                option-text="jt"
                placeholder=" JobType"
                @input="SearchFilter"
              ></model-list-select>
            </b-col>
            <b-col  md="3"
              ><label>Status</label>
              <model-list-select
                :list="filterstatusList"
                v-model="Filter.statusFilter"
                option-value="payVal"
                option-text="payText"
                placeholder="Select Status"
                @input="SearchFilter"
              ></model-list-select>
            </b-col>
            <b-col  md="3"
              ><label>SOB Status</label>
              <model-list-select
                :list="SOBStatusList"
                v-model="Filter.SOBFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select SOB Status"
                @input="SearchFilter"
              ></model-list-select>
            </b-col>
            
            <b-col  md="3">
              <label>Branch</label>
              <model-list-select
                :list="$store.getters['common/getAllBranchList']"
                id="branchfilter"
                v-model="Filter.branchfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="All"
                @input="SearchFilter"
              ></model-list-select>
            </b-col>
            <b-col md="12">
              <label for="blType">Common Filter </label>
              <b-form-input
                :formatter="capitalizeAll"
                v-model="Filter.CommonFilter"
                @input="SearchFilter"
                placeholder="Type To Search (Assignment No. / Client / Container No. / Shipping Line / BL NO / Proforma NO / HBL )"
              />
            </b-col>
            <b-col md="3" class="mt-4"> </b-col>
          </b-row>
          <b-row class="align-content-end mt-3">
            <b-col md="6">
              <input
                type="checkbox"
                @click="SelectAll(CDCRARR)"
                v-model="isCheckAll"
              />
              <label
                >Select / Deselect All Count({{ this.profarma_ids.length }})</label
              >
              <b-button
                v-if="profarma_ids.length > 0"
                size="sm"
                @click="ProceedMultiPayment"
                variant="outline-primary"
                >Multi Payment</b-button
              >
            </b-col>
            <b-col md="2">
              <h5 class="text-muted pull-right">
                <small v-if="isLoading == false">{{ totalRows }} Entries</small>
              </h5>
            </b-col>
            <b-col md="4" style="padding: 0px 1rem 0 1rem">
              <model-list-select
                :list="PaginationList"
                v-model="PaginationCount"
                option-value="pagv"
                option-text="pagt"
                placeholder="Select"
                @input="pagechangeData()"
              ></model-list-select>
            </b-col>
          </b-row>
        </b-card>

        <!-- Main table element -->
        <div class="table-responsive tableMain">
          <b-table
            show-empty
            stacked="md"
            :items="CDCRARR"
            responsive
            :fields="Columns"
            primary-key="profarma_id"
            :per-page="pagination.perPage"
            :current-page="pagination.currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            class="position-relative"
          >
            <template slot="profarma_id" slot-scope="row0">
              <input
                v-if="row0.item.payStatus != '1' && row0.item.payStatus != '2'"
                type="checkbox"
                v-bind:value="row0.item.profarma_id"
                v-model="profarma_ids"
                @change="updateSelectAll($event, row0.item)"
              />
              <span>{{
                row0.index +
                1 +
                (pagination.currentPage - 1) * pagination.perPage
              }}</span>
            </template>
            <template slot="profarmaSeries" slot-scope="row1">
              <span variant="info"
                >Profarma No.: <b>{{ row1.item.profarmaSeries }}</b></span
              ><br />
              <span variant="info"
                >Created: <b>{{ row1.item.profarmaDate }}</b></span
              ><br />
            </template>
            <template slot="note_type" slot-scope="row2">
              <span variant="info"
                ><b>{{
                  row2.item.note_type == "CR" ? "Credit" : "Debit"
                }}</b></span
              ><br />
            </template>
            <template slot="AgentColoader" slot-scope="row3">
              <span variant="info"
                ><b>{{ row3.item.AgentColoader }}</b></span
              ><br />
            </template>
            <template slot="mainSalesSeries" slot-scope="row4">
              <span
                >Ass No: <b>{{ row4.item.mainSalesSeries }}</b></span
              ><br />
              <span
                >Ass Date: <b>{{ row4.item.assDate }}</b></span
              ><br />
              <span
                >Ass Branch: <b>{{ row4.item.raisedFrom }}</b></span
              ><br />
            </template>


            <template slot="action" slot-scope="row4">
              <!-- {{row4.item}} -->
              <b-button
                v-if="row4.item.profarma_id"
                @click="PrintNote(row4.item.jobNo,row4.item.proformaPdf)"
                size="sm"
                variant="outline-success"
                >PDF</b-button
              >
              <b-button
                style="font-size: 0.675rem ;margin-left: 5px"
                @click="
              proceedAssignmentProforma(
                row4.item.allModuleId,
                0,
                row4.item.jobNo
              )
            "
               
                size="sm"
                class="ml-1"
                variant="outline-info"
              >Proceed To Proforma</b-button>
            </template>
          </b-table>
        </div>
        <h5>
          <b-row>
            <b-col md="12" class="my-1">
              <b-pagination
                limit="8"
                align="center"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total-rows="totalRows"
                @change="onPageChange($event)"
              ></b-pagination>
            </b-col>
          </b-row>
        </h5>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import CommonService from "../../services/CommonService.js";
import { ModelListSelect } from "vue-search-select";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  URL_BASE,
  URL_BASE_DOC,
  PRIDELdashboardName,
} from "../../helper/constant.js";
import { DateFormat, selectDateFormat, wordWrap } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import ClientCard from "../common/clientCard.vue";
import ShipmentTrackCard from "../common/ShipmentTrackCard.vue";
import AddMessage from "../allModuleForm/addMessage.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";
import DateRangePicker from "vue2-daterange-picker";
import CustomLoader from "../common/customLoader.vue";
import XLSX from "xlsx";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    this.getCurrentLastDate();

    this.$store.dispatch("common/setAllBranchList",JSON.stringify({}));
    this.$store.dispatch(
      "common/setAllBillingLocationList",
      JSON.stringify({
        itemCode: "BillingLocationList",
      })
    );
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );

    this.$store.dispatch(
      "common/setAllAirLineList",
      JSON.stringify({
        itemCode: "AirLineList",
      })
    );

    this.$store.dispatch(
      "common/setAllLocationDetailsFinalList",
      JSON.stringify({
        itemCode: "LocationDetailsFinalList",
      })
    );
    this.$store.dispatch(
      "common/setAllPORList",
      JSON.stringify({
        itemCode: "PORList",
      })
    );
    this.$store.dispatch(
      "common/setAllPODList",
      JSON.stringify({
        itemCode: "PODList",
         type:'Normal',
        Territory:'',
      })
    );
    this.$store.dispatch(
      "common/setAllPOLList",
      JSON.stringify({
        itemCode: "POLList",
      })
    );

    this.$store.dispatch(
      "common/setAllContainerTypeList",
      JSON.stringify({
        itemCode: "ContainerTypeList",
      })
    );
    if (globalPermissionStatus("Overseas Agent Assignments")) {
      this.$store.dispatch("setCurrentRoute", "/overseas/OverseasAgentSOA");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.getAllProformaInvoice();
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      isCheckAll: false,
      profarma_ids: [],
      selectedprofarma_ids: "",
      PaginationList: [
        {
          pagv: "25",
          pagt: "25",
        },
        {
          pagv: "50",
          pagt: "50",
        },
        {
          pagv: "75",
          pagt: "75",
        },
        {
          pagv: "100",
          pagt: "100",
        },
        {
          pagv: "125",
          pagt: "125",
        },
        {
          pagv: "150",
          pagt: "150",
        },
        {
          pagv: "175",
          pagt: "175",
        },
        {
          pagv: "200",
          pagt: "200",
        },
        {
          pagv: "225",
          pagt: "225",
        },
        {
          pagv: "250",
          pagt: "250",
        },
        {
          pagv: "275",
          pagt: "275",
        },
        {
          pagv: "300",
          pagt: "300",
        },
        {
          pagv: "325",
          pagt: "325",
        },
        {
          pagv: "350",
          pagt: "350",
        },
        {
          pagv: "375",
          pagt: "375",
        },
        {
          pagv: "400",
          pagt: "400",
        },
      ],
      PaginationCount: "",
      validate: true,
      currList: [],
      Filter: {
        SOBFilter: "3",
        statusFilter: "3",
        jobTypeFilter: "All",
        airLineFilter: "",
        shippingLineFilter: "",
        containerTypeFilter: "",
        PODfilter: "",
        PORfilter: "",
        InvoiceNoFilter: "",
        clientIdFilter: "",
        CommonFilter: "",
      },
      selectDateFormat,
      openLeft: "right",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      docURL: URL_BASE_DOC,
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),

      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },

      totalRows: 0,

      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      changePageFilter: "0",
      CDCRARR: [],
      Columns: [
        {
          key: "profarma_id",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "profarmaSeries",
          label: "Profarma No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "mainSalesSeries",
          label: "Assignment No",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "clientName",
          label: "Client",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "shippingLine",
          label: "Shipping Line",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "action",
          label: "Action",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      filterstatusList: [
        {
          payVal: "1",
          payText: "Active",
        },
        {
          payVal: "2",
          payText: "In-Active",
        },
        {
          payVal: "3",
          payText: "All",
        },
      ],
      jobList: [
        {
          jv: "FF",
          jt: "FF",
        },
        {
          jv: "CC",
          jt: "CC",
        },
        {
          jv: "TPT",
          jt: "TPT",
        },
        {
          jv: "All",
          jt: "All",
        },
      ],
      SOBStatusList: [
        {
          inv: "1",
          int: "Sailed",
        },
        {
          inv: "2",
          int: "Not Sailed",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  components: {
    Loading,
    ModelListSelect,
    DocForm,
    FilterAgencyModal,
    FilterCBModal,
    ClientCard,
    ShipmentTrackCard,
    AddMessage,
    AssignmentSummary,
    DateRangePicker,
    DatePicker,
    CustomLoader,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.Columns.filter((f) => f.sortable).map((f) => {
        return { text: f.label, value: f.key };
      });
    },
  },
  watch: {
    milestoneFiltersD: {
      handler(newVal, oldVal) {},
      deep: true,
    },
  },

  methods: {
    proceedAssignmentProforma(
      all_module_id,

      isConsolidation,
      mainSalesSeries
    ) {
      // newContainerFlow,
      this.$sessionsStorage.set("editSalesExId", all_module_id);
      if (isConsolidation == "1") {
        console.log("Consolidation");
        this.$router.push({
          path: "/consolidation/viewBillingDetails/" + all_module_id,
          query: { mainSalesSeries: mainSalesSeries }
        });
      } else {
        this.$router.push({
          path: "/common/assignmentPerforma/" + all_module_id
        });
      }
    },
    // ExportSOAExcel() {
    //   if (this.CDCRARR.length > 0) {
    //     var dataOne = XLSX.utils.json_to_sheet(this.CDCRARR);
    //     var wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, dataOne, "Overses_Agent_SOA");
    //     let ExcelDate = new Date().toDateString();
    //     if (this.dateSearch.fromDate) {
    //       ExcelDate = new Date(this.dateSearch.fromDate).toDateString();
    //     } else {
    //       ExcelDate = new Date().toDateString();
    //     }
    //     XLSX.writeFile(
    //       wb,
    //       `${PRIDELdashboardName.toUpperCase()}_Overses_Agent_SOA_DETAILS_Report_${ExcelDate}.xlsx`
    //     );
    //   }
    // },
    getReportsReverse(id) {
      let excelIdGivin = "";
      if (id == "Proforma_EXCEL") {
        excelIdGivin = "Proforma_EXCEL";
      }
      let payload = {
        excelId: excelIdGivin,
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        Filter: this.Filter,
      };
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        ExcelName =
          this.$store.getters["common/getAllPendingReverseTallyExcel"];
      }
    },
    PrintNote(assignmentNo, uploadCreditDebit) {
      this.openSignedDocument(`ASSIGNMENT_UPLOADS/${assignmentNo.replaceAll("/", "_")}/${uploadCreditDebit}`);
    },

    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      // alert(firstDay);
      // alert(lastDay);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      let firstYear = firstDay_mm > 3 ? firstDay_yyyy : firstDay_yyyy - 1;
      let newdate = firstYear + "-04-01";
      firstDay = new Date(newdate);

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      // alert(today);
    },
    // async
    getAllProformaInvoice() {
      this.isLoading = true;
      let payload = {
        itemCode: "AllProformaListDash",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        Filter: this.Filter,
      };
      // JSON.stringify();
      // await
      CommonService.getAllProformaInvoice(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.CDCRARR = data.AllProformaList;
            this.totalRows = data.AllProformaList.length;
            console.log(" Proforma response=>", data);
          } else {
            this.CDCRARR = [];
          }
          this.isLoading = false;
          this.PaginationCount = this.pagination.perPage;
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },

    SearchFilter(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllProformaInvoice();
      }, 1000);
    },
    pagechangeData() {
      this.pagination.perPage = this.PaginationCount;
      this.reload = false;
      this.getAllProformaInvoice();
    },

    wordWrap,
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT =
          parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getAllProformaInvoice();
    },
    filterClear() {
      (this.Filter = {
        SOBFilter: "3",
        statusFilter: "3",
        jobTypeFilter: "All",
        airLineFilter: "",
        shippingLineFilter: "",
        containerTypeFilter: "",
        PODfilter: "",
        PORfilter: "",
        InvoiceNoFilter: "",
        clientIdFilter: "",
        CommonFilter: "",
      }),
        (this.dateSearch.fromDate = "");
      this.dateSearch.toDate = "";
      this.getCurrentLastDate();
      this.getAllProformaInvoice();
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set(
        "oldRoute",
        this.$router.history.current.fullPath
      );
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getAllProformaInvoice();
    },
    SelectAll: function () {
      this.isCheckAll = !this.isCheckAll;
      this.profarma_ids = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.CDCRARR) {
          if (
            this.CDCRARR[key].payStatus != 1 &&
            this.CDCRARR[key].payStatus != 2
          ) {
            let single_data = "";
            this.profarma_ids.push(this.CDCRARR[key].profarma_id);
          }
        }
      }
    },
    updateSelectAll: function (e, item) {
      if (this.profarma_ids.length == this.CDCRARR.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
      const istrue = this.profarma_ids.includes(item.profarma_id);
      if (istrue == true) {
        const index = this.profarma_ids.indexOf(item.profarma_id);
        this.profarma_ids.splice(index, 1);
      }
    },

    // Main Table
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.pagination.currentPage = 1;
    },

    // Added By Priyanshu SIngh End
  },
};
</script>
<style scoped>
.colwidth {
  min-width: 200px !important;
}
a:not(.md-button):not(.md-bottom-bar-item):hover {
  text-decoration: none !important;
}
</style>



// WEBPACK FOOTER //
// proformaList.vue?194d9c8a